import React from "react";

import { faInfoCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import uuid from "uuid";

import { Checkbox, LoadingSpinner } from "~/ui";
import Popup from "~/ui/legacy/Popup";

import styles from "./css/IncludeAIRecapCheckbox.module.css";

interface Props {
	hasMeetingRecordings: boolean | null;
	onCheckedChange: (checked: boolean) => void;
	checked: boolean | null;
}

export const IncludeAIRecapCheckbox: React.FunctionComponent<Props> = ({
	hasMeetingRecordings,
	onCheckedChange,
	checked,
}) => {
	const checkboxid = React.useRef(uuid.v4());

	const toolTipContent = hasMeetingRecordings
		? "Includes: Recording, highlights, stats and any clips."
		: "There is no Recap for this meeting.";

	const isLoading = hasMeetingRecordings === null || checked === null;

	if (isLoading) {
		return <LoadingSpinner />;
	}

	return (
		<div
			className={cx(styles.includeMeetingRecapContainer, {
				[styles.disabled]: !hasMeetingRecordings,
			})}
		>
			<Checkbox
				id={checkboxid.current}
				checked={checked}
				onCheckedChange={onCheckedChange}
				disabled={!hasMeetingRecordings}
				className={styles.checkbox}
			/>
			<label htmlFor={checkboxid.current} className={styles.label}>
				Include AI Recap
			</label>

			<Popup
				inverted
				position="top center"
				size="tiny"
				trigger={<FontAwesomeIcon icon={faInfoCircle} className={styles.warningIcon} />}
				content={toolTipContent}
			/>
		</div>
	);
};
